/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/

import i18n from 'i18next';
import de from './translations/de.mjs'
import en from './translations/en.mjs'
import fr from './translations/fr.mjs'
import { initReactI18next } from 'react-i18next';
import { Translation } from './store/interfaces';
import countries from 'i18n-iso-countries';


import english from 'i18n-iso-countries/langs/en.json';
import german from 'i18n-iso-countries/langs/de.json';
import french from 'i18n-iso-countries/langs/fr.json';

countries.registerLocale(english);
countries.registerLocale(german);
countries.registerLocale(french);

const resources = {
    de,
    en,
    fr
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'de',
    
        interpolation: {
            escapeValue: false
      }
});

export function translate(text: Translation, i: typeof i18n): string {
    if(text !== undefined && text !== null && text.hasOwnProperty(i.language)) {
        return (text as any)[i.language] as string;
    }
    return `Translation not found for language ${i.language}.`;
}

export function getCountry(shortCode: string, language: string) {
    return countries.getName(shortCode, language);
}

export default i18n;